var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessPopupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 100,
    viewBox: "0 0 75 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7736 90.4762C43.1571 90.4762 41.036 92.6082 41.036 95.2381C41.036 97.868 43.1571 100 45.7736 100C48.3901 100 50.5112 97.868 50.5112 95.2381C50.5112 92.6082 48.3901 90.4762 45.7736 90.4762ZM22.6777 78.5714C19.08 78.5714 16.1635 81.5029 16.1635 85.119C16.1635 88.7352 19.08 91.6667 22.6777 91.6667C26.2754 91.6667 29.1919 88.7352 29.1919 85.119C29.1919 81.5029 26.2754 78.5714 22.6777 78.5714ZM41.036 11.9048C22.7204 11.9048 7.87269 26.8286 7.87269 45.2381C7.87269 63.6476 22.7204 78.5714 41.036 78.5714C41.4635 78.5714 41.8892 78.5633 42.3129 78.5472C44.5536 83.4778 49.503 86.9048 55.2488 86.9048C63.0983 86.9048 69.4616 80.5088 69.4616 72.619C69.4616 69.9645 68.7413 67.479 67.4864 65.3494C71.6991 59.7596 74.1992 52.7923 74.1992 45.2381C74.1992 26.8286 59.3515 11.9048 41.036 11.9048ZM65.3162 0C63.0268 0 61.1708 1.86548 61.1708 4.16667C61.1708 6.46785 63.0268 8.33333 65.3162 8.33333C67.6056 8.33333 69.4616 6.46785 69.4616 4.16667C69.4616 1.86548 67.6056 0 65.3162 0Z",
    fill: "#50E35F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4439 78.5714C55.6048 78.5714 71.1378 63.0384 71.1378 43.8775C71.1378 24.7166 55.6048 9.18359 36.4439 9.18359C17.283 9.18359 1.75 24.7166 1.75 43.8775C1.75 63.0384 17.283 78.5714 36.4439 78.5714Z",
    stroke: "#29313A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7856 49.0811C17.6198 57.9654 26.4587 64.1838 36.7501 64.1838C47.0019 64.1838 55.8124 58.0131 59.6701 49.1832",
    stroke: "#29313A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPopupIcon);
export default __webpack_public_path__ + "static/media/successPopupIcon.d449c3f21797d79f0ca2a85c74ca70ae.svg";
export { ForwardRef as ReactComponent };